/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import React from "react";
import Head from "next/head";
import Header from "../../common/header/Header";
import Footer from "../../common/footer/Footer";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      h2: "h2",
      ul: "ul",
      li: "li",
      a: "a"
    }, props.components);
    return _jsxs("main", {
      className: "page-wrapper",
      children: [_jsx(Head, {
        children: _jsx("title", {
          children: "Modulabs | Until the End of the Internet Policy"
        })
      }), _jsx(Header, {
        className: "header-not-transparent"
      }), _jsx("div", {
        className: "post-page-banner rn-section-gapTop",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content text-center",
                children: _jsx("div", {
                  className: "page-title",
                  children: _jsx("h1", {
                    className: "theme-gradient",
                    children: "Until the End of the Internet"
                  })
                })
              })
            })
          })
        })
      }), _jsx("div", {
        className: "blog-details-content pt--60 rn-section-gapBottom",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content",
                children: _jsxs("div", {
                  children: [_jsx(_components.p, {
                    children: "Internet software and services disappear all the time because of whimsy (“changing\npriorities”), acquisition, financial failure, or worse. It’s become a risky venture to place\nyour trust and data in services that could disappear at any moment, for any reason, and with\nno guarantee that your data will be safe, preserved, or even portable."
                  }), _jsx(_components.p, {
                    children: "We want more for our customers."
                  }), _jsx(_components.p, {
                    children: "When they launched, each of our products was our finest work. They were the result of\ncountless hours laboring to build software that is simple, clear, easy-to-use, and honest.\nThey remind us where we’ve been, how we got here, and point to where we’re going. We’re\nproud of these products and honored by all the customers who have supported us over the\nyears, who made our tools partners in their success, and who continue to rely on them every\nday."
                  }), _jsx(_components.h2, {
                    children: "It’s a promise to our customers"
                  }), _jsx(_components.p, {
                    children: "We’re dedicated to supporting our products forever (or until the last customer turns off the\nlights). We stand against the tide of ephemeral software and services that are frustratingly\ncommon on the Internet. Modulabs is built to last. Supporting our legacy products and\ncustomers who love them isn’t free or easy but it’s the right thing to do. We’ll be here\nuntil the end of the Internet."
                  }), _jsx(_components.p, {
                    children: "Here’s what that means:"
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsxs(_components.li, {
                      children: ["The day you become a customer of any of our products, you can trust that Modulabs will be\naround. In the event that the Modulabs product you’re using enters a legacy phase you’ll be\nable to keep using it indefinitely, assuming you continue to abide by our ", _jsx(_components.a, {
                        href: "./",
                        children: "terms of\nservice"
                      }), " and keep your subscription active. We work hard to keep\nsupporting existing features unless it becomes technically impossible to do so for reasons\nout of our control (e.g. changes to 3rd party integrations that makes a feature incompatible\nor browser upgrades that leave a feature behind)."]
                    }), "\n", _jsxs(_components.li, {
                      children: ["Your data is safe. Regardless of status, all of our products receive the same rigorous\ncare when it comes to ", _jsx(_components.a, {
                        href: "./security",
                        children: "security"
                      }), " and ", _jsx(_components.a, {
                        href: "./privacy",
                        children: "privacy"
                      }), ".\nWhile we may not add new features to legacy products we’ll continue to apply the latest\nsecurity updates; maintain the infrastructure that keeps them safe, fast and secure; and\ncontinue to offer ", _jsx(_components.a, {
                        href: "mailto:support@modulabs.io",
                        children: "customer support"
                      }), "."]
                    }), "\n", _jsx(_components.li, {
                      children: "This is our life’s work — we’re in this for the long haul. In the unforeseen and\nunanticipated event that the company or one of our products is acquired by another company\nor spun-off into a separate company, we’ll do everything in our power to make sure the\nproduct and this promise live on."
                    }), "\n"]
                  }), _jsx(_components.h2, {
                    children: "Changes & questions"
                  }), _jsx(_components.p, {
                    children: "We will notify customers about significant changes by emailing the account owner or by\nplacing a prominent notice on our site."
                  }), _jsxs(_components.p, {
                    children: ["Questions about this policy? ", _jsx(_components.a, {
                      href: "mailto:support@modulabs.io",
                      children: "Get in touch"
                    }), " and we’ll be happy to\nanswer them!"]
                  }), _jsxs(_components.p, {
                    children: ["Adapted from the ", _jsx(_components.a, {
                      href: "https://github.com/basecamp/policies",
                      children: "Basecamp open-source policies"
                    }), " / ", _jsx(_components.a, {
                      href: "https://creativecommons.org/licenses/by/4.0/",
                      children: "CC\nBY 4.0"
                    })]
                  })]
                })
              })
            })
          })
        })
      }), _jsx(Footer, {})]
    });
  }
}
export default MDXContent;
